export default __webpack_public_path__ + "static/media/cora-logo.9f80b325.svg";